// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"YX-z","sponsoredTooltipWrapper":"ZX-z","sponsoredTooltip":"_X-z","newCard":"aY-z"};